import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DEFAULT_BRIGHTNESS } from '../../../../cross-team-shared/state/layer-settings-state-2d';
import { AbstractViewSettingsImageSliderComponent } from './abstract-view-settings-image-slider-component.directive';

@Component({
  selector: 'h3-view-settings-brightness-slider',
  templateUrl: './view-settings-brightness-slider.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewSettingsBrightnessSliderComponent extends AbstractViewSettingsImageSliderComponent {
  override readonly settingName = 'brightness';
  defaultBrightness = DEFAULT_BRIGHTNESS;
}
